module.exports = __webpack_public_path__ + "d67cfc49f1f54596e0d8270aa176ecd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/faction_campaign_2-660.jpg
// module id = 295
// module chunks = 0